import { gql } from "graphql-tag";

export const QUERY_INTEREST_PROFILE = gql`
  query QueryInterestProfile($interestId: ID!) {
    interest(id: $interestId) {
      id
      userId
      linkCode
      updatedAt
      submittedAt
      status {
        name
        changedAt
      }
      householdMember0FirstName
      householdMember0LastName
      householdMember0PrimaryPhone
      householdMember0PrimaryPhoneType
      householdMember0SecondaryPhone
      householdMember0SecondaryPhoneExt
      householdMember0Email
      residenceAddress1
      residenceSteNumber
      residenceCity
      residenceState
      residenceZip
      mailingAddress1
      mailingSteNumber
      mailingCity
      mailingState
      mailingZip
      householdGrossAnnualIncome
      householdHasHousingAuthorityVoucher
      householdReceivesOtherHousingAssistance
      householdCount
      householdRequiresImpairmentHearing
      householdRequiresImpairmentVisual
      householdRequiresImpairmentMobility
      contactName
      contactRelation
      contactEmail
      contactPrimaryPhone
      contactPrimaryPhoneExt
      applicantFirstName
      applicantLastName
      applicantPhonePrimary
      applicantPhoneSecondary
      applicantPhoneSecondaryExt
      applicantEmail
      mailingAddressType
      unitSize
      unitSizeSro
      unitSizeStudio
      unitSize1br
      unitSize1brDen
      unitSize2br
      unitSize3br
      unitSize4br
      unitSize5br
      prefMoveInDate
      signatureId
      skips
      prefLang
      hasEligibility
      positionNumber

      updateRequest {
        isActive
        updateUrl
      }

      user {
        loginEmail
        loginPhone
      }

      interestList {
        id
        name
        defaultSorting
        property {
          id
          stages {
            id
            name
            enabled
            standard
          }
          features {
            id
            name
          }
          propertyUseCases {
            id
          }
        }
      }
    }
  }
`;
